export const TOKEN_APP_CONFIG = 'TOKEN_APP_CONFIG';